module.exports = __webpack_public_path__ + "img/icon33.8b42816f.png";